import { createContext, useContext } from 'react';
import type { AuthMode } from '@/config/env';

export interface CompteAuth {
  nom: string;
  upn: string;
}

export interface AuthState {
  mode: AuthMode;
  autenticat: boolean;
  carregant: boolean;
  compte: CompteAuth | null;
  login: () => Promise<void>;
  logout: () => Promise<void>;
  obteToken: () => Promise<string | null>;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('AuthContext absent');
  return ctx;
}
